module.exports = __webpack_public_path__ + "img/face-scan-avatar.dadf3264.png";